import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseReadOnlyService } from '../../services/base-readonly.service';
import { CertificationType } from './certification-type.model';

@Injectable({
    providedIn: 'root'
})
export class CertificationTypeService extends BaseReadOnlyService<CertificationType> {

    constructor(protected http: HttpClient) {
        super(http, 'certificationtype');
    }
}
